import { React, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { addServiceWiseSaleData } from "../../redux/slices/currentUserSlice";
import OtherService from "../../services/Other.js";
import BigBox from "../BigBox.js";
import Box from "../Box.js";
import { env } from "../../configs/EnvironmentConfig.js";
import { Spinner } from "react-bootstrap";
import { Empty, Button } from "antd";
import { useNavigate } from 'react-router-dom';

const ServiceWiseLift = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [hierName, setHiername] = useState(null);
  const [saleData, setSaleData] = useState();
  const [businessTimeframe, setBusinessTimeframe] = useState("MTD");
  const [loading, setLoading] = useState(false);

  const brandId = JSON.parse(localStorage.getItem("currentBrand")).id;

  useEffect(() => {
    trigger();
  }, [brandId]);

  const trigger = async () => {
    const hierDesc = JSON.parse(localStorage.getItem("userData")).hierCode;
    setHiername(hierDesc);
    if (hierDesc === "contractor" || hierDesc === "TSE") {
      getMyServicePerformanceData("MTD");
    }
  };

  const getMyServicePerformanceData = async (option) => {
    try {
      setLoading(true);
      let payload = {
        business_timeframe: option,
        type: "service",
      };
      const res = await OtherService.getSalePerformanceData(payload);
      if (res.success === true) {
        setSaleData(res.response.totalQuantity);
        dispatch(
          addServiceWiseSaleData({
            serviceWiseSaleData: res.response.totalQuantity,
          })
        );
      } else {
        setSaleData([]);
      }
    } catch (error) {
      console.error("getMySalePerformanceData api error");
      setSaleData([]);
    } finally {
      setLoading(false);
    }
  };

  const changeBusinessTimeFrameService = (option) => {
    setBusinessTimeframe(option);
    getMyServicePerformanceData(option);
  };

  return (
    <>
      <BigBox
        header={
          hierName === "TSE"
            ? "Service -wise Lifting"
            : "Points Earned from Service"
        }
        options={["MTD", "YTD"]}
        selectedOption={businessTimeframe}
        onChange={changeBusinessTimeFrameService}
      >
        {loading ? (
          <div
            style={{
              padding: "16px",
              display: "flex",
              justifyContent: "space-evenly",
              margin: "8px",
              color: "#000",
              maxHeight: "112px",
              maxWidth: "202px",
              minWidth: "202px",
              minHeight: "112px",
            }}
          >
            <p className="text-[16px] text-slate-600 font-medium">Loading...</p>
          </div>
        ) : Array.isArray(saleData) && saleData.length > 0 ? (
          saleData.map((item, index) => {
            const img = env.API_IMAGE_BASE_URL + item?.product_image;
            return (
              <Box column={2} bgColor={item?.color} key={index}>
                <div
                  style={{
                    display: "flex",
                    gap: "16px",
                    justifyContent: "center",
                    marginTop: "10px",
                  }}
                >
                  <div
                    style={{
                      width: "min(45%, 200px)",
                      aspectRatio: "16/9",
                    }}
                  >
                    <img
                      src={img}
                      alt="Service-wise lifting stats"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                </div>

                <div
                  className="text-left w-4/5"
                  style={{
                    padding: "16px",
                    color: "#000",
                    maxHeight: "112px",
                    maxWidth: "100%",
                    minWidth: "202px",
                  }}
                >
                  <p className="text-[12px] text-[#222] text-center font-sans font-bold">
                    {Math.round(item?.total_quantity)} Units
                  </p>
                  {hierName === "contractor" && (
                    <p className="text-[12px] text-[#222] text-center font-sans font-bold">
                      {Math.round(item?.points_earned)} Points
                    </p>
                  )}
                </div>
              </Box>
            );
          })
        ) : (
          <div
            style={{
              padding: "16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "8px",
              color: "#000",
              width: "100%",
              minHeight: "200px",
            }}
          >
            {/* <p className="text-[18px] font-bold text-slate-600 text-center">
              No data found !!!
            </p> */}
            <Empty
              // image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No records found"
              classNames={{root: "my-classname"}} styles={{root: {color: "red"}}}
            >
              <Button type="primary" onClick={() => navigate("/service-registration")}>Check my service</Button>
            </Empty>
          </div>
        )}
      </BigBox>
    </>
  );
};

export default ServiceWiseLift;

